import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <div className="aspect-[21/9] md:aspect-[3/1]">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20reading%20atmosphere%2C%20warm%20amber%20and%20soft%20cream%20gradient%2C%20abstract%20book%20and%20coffee%20aesthetic%2C%20cozy%20evening%20mood%2C%20minimal%20digital%20art%20with%20film%20grain%20texture%2C%20no%20text%2C%20atmospheric%20lighting&width=1600&height=600&seq=cta-section-home&orientation=landscape"
              alt="开始阅读韩国漫画"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/20 flex items-center">
            <div className="px-6 md:px-12 py-10 max-w-xl">
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-white mb-3 leading-tight">
                准备好了吗？
                <span className="block text-accent-400 italic font-normal">开启你的韩漫之旅</span>
              </h2>
              <p className="text-white/70 text-sm md:text-base mb-6 leading-relaxed">
                上千部精品韩国漫画等你来发现，现在就开始免费阅读吧
              </p>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-7 py-3 bg-background-950 text-white text-sm font-medium rounded-full hover:bg-background-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                立即开始 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}